import register from '../../../../global/js/registry';
export default register('m-hero-contact-selector', () => import(/* webpackMode: "lazy" */ './m-hero-contact-selector.controller'));
